const Content = {
  'homepage': {
    'video': {
      'webm': '../assets/videos/01-thinking.webm',
      'mp4': '../assets/videos/01-thinking.mp4',
      'jpg': '../assets/videos/01-thinking.jpg'
    },
    'number': '01',
    'title': 'Insights for bold storytellers everywhere'
  },
  'services': {
    'video': {
      'webm': '../assets/videos/02-services.webm',
      'mp4': '../assets/videos/02-services.mp4',
      'jpg': '../assets/videos/02-services.jpg'
    },
    'number': '02',
    'title': 'Understanding unmet needs and desires'
  },
  'expertise': {
    'video': {
      'webm': '../assets/videos/03-expertise.webm',
      'mp4': '../assets/videos/03-expertise.mp4',
      'jpg': '../assets/videos/03-expertise.jpg'
    },
    'number': '03',
    'title': 'Ideas that unlock memorable experiences'
  },
  'people': {
    'video': {
      'webm': '../assets/videos/04-people.webm',
      'mp4': '../assets/videos/04-people.mp4',
      'jpg': '../assets/videos/04-people.jpg'
    },
    'number': '04',
    'title': 'We beat to the rhythm of pop culture'
  },
  'network': {
    'video': {
      'webm': '../assets/videos/05-contact.webm',
      'mp4': '../assets/videos/05-contact.mp4',
      'jpg': '../assets/videos/05-contact.jpg'
    },
    'number': '05',
    'title': 'Let\'s get to the heart of your story'
  },
  'news': {
    'video': {
      'webm': './../../assets/videos/06-news.webm',
      'mp4': './../../assets/videos/06-news.mp4',
      'jpg': './../../assets/videos/06-news.jpg'
    },
    'number': '06',
    'title': 'Feed your curiosity'
  }
};

export { Content };
